import React, { useEffect, useState, useMemo } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useParams } from "react-router-dom";
import CircularProgress from "@mui/material/CircularProgress";
import { DataGrid } from "@mui/x-data-grid";
import { Box, Autocomplete, TextField, Button, Stack, InputAdornment, IconButton, Tooltip, Tabs, Tab, Select, MenuItem } from "@mui/material";
import moment from "moment";
import SearchIcon from "@mui/icons-material/Search";
import CloseIcon from "@mui/icons-material/Close";
import { exportToCsv } from "../../utils/utilFunctions";
import {
  getServiceTicketsForTheLastXDays,
  readServiceTicket,
  getSvcTktDetailsForWhatsappMessage,
} from "../../features/servicetickets/actions";
import { readMachinesByCustomerId } from "../../features/customers/actions";
import ZoomInIcon from "@mui/icons-material/ZoomIn";
import WhatsAppIcon from "@mui/icons-material/WhatsApp";
import { useNavigate } from "react-router-dom";
import AddIcon from "@mui/icons-material/Add";
import EditIcon from "@mui/icons-material/Edit";
import { readAsyncStorageValues } from "../../features/common/actions";
import ContentCopy from "@mui/icons-material/ContentCopy";
import { getAverageResolutionTimeByMonthCustomer } from "../../features/dashboard/actions";
import { getAppUsers } from "../../features/users/actions";
const AllSvcTicketForLastXDays = () => {
  const dispatch = useDispatch();
  const [activeTab, setActiveTab] = useState(0);
  const { serviceTicketsForCustomer } = useSelector((state) => state.customers);
  const { appUsersList } = useSelector((state) => state.users);
  const { appConstants } = useSelector((state) => state.common);
  const { allSvcTickets, svcTicketsDetailsView, whatsappMessages } = useSelector((state) => state.serviceTickets);
  const { averageResolutionTimeByMonthCustomer } = useSelector((state) => state.dashboard);
  const [days, setDays] = useState("30");
  const [loading, setLoading] = useState(false);
  const [searchTerm, setSearchTerm] = useState("");
  const navigate = useNavigate();
  const [selectedCategory, setSelectedCategory] = useState(null);
  const [selectedStatus, setSelectedStatus] = useState(null);
  const [selectedServiceEngineer, setSelectedServiceEngineer] = useState(null);
  const [categoryList, setCategoryList] = useState([]);
  const { userInfo, userCurrentRole } = useSelector((state) => state.auth);
  const { asyncStorageValues } = useSelector((state) => state.common);
  const [filters, setFilters] = useState({ engineer: "", category: "", status: "", customer: "", creator: "" });
  const [additionalNotes, setAdditionalNotes] = useState(null);
  useEffect(() => {
    dispatch(getAppUsers());
    // console.log("allSvcTickets: ", allSvcTickets);
    // console.log("appUsersList: ", appUsersList);
    // console.log("Type of appUsersList:", typeof appUsersList);

    if (asyncStorageValues?.allTypes?.SERVICE_CATEGORY) {
      const { SERVICE_CATEGORY } = asyncStorageValues?.allTypes;
      const ticketCategories = asyncStorageValues?.usedTicketCategories.map((item) => {
        if (SERVICE_CATEGORY[item]) return SERVICE_CATEGORY[item];
      });
      setCategoryList(ticketCategories);
    }
  }, [asyncStorageValues]);

  useEffect(() => {
    if (userInfo && Object.keys(userInfo).length) dispatch(readAsyncStorageValues());
  }, [dispatch, userInfo]);
  useEffect(() => {
    const fetchCustomerServiceTickets = async () => {
      try {
        await dispatch(getServiceTicketsForTheLastXDays(days));
      } catch (error) {
        console.error("Error fetching service tickets:", error);
      } finally {
        setLoading(false);
      }
    };

    if (days) {
      setLoading(true);
      fetchCustomerServiceTickets();
    }
  }, [days, dispatch.activeTab]);
  useEffect(() => {
    if (svcTicketsDetailsView && svcTicketsDetailsView.customer?.id) {
      const customerId = svcTicketsDetailsView.customer.id;
      dispatch(readMachinesByCustomerId(customerId));
    }
  }, [dispatch, svcTicketsDetailsView]);
  useEffect(() => {
    dispatch(getAverageResolutionTimeByMonthCustomer());
  }, [dispatch]);

  const FilterDropdown = ({ label, value, options, onChange }) => {
    const sortedOptions = [...options].sort((a, b) => a.localeCompare(b));
    return (
      <Select
        value={value}
        onChange={(e) => onChange(e.target.value)}
        displayEmpty
        style={{ width: "100%", fontSize: "0.875rem", fontWeight: value ? "normal" : 500 }}
        renderValue={(selected) => selected || <span style={{ fontWeight: 500 }}>{label}</span>}
      >
        <MenuItem value="" style={{ fontWeight: 500 }}>
          {label}
        </MenuItem>
        {sortedOptions.map((option) => (
          <MenuItem key={option} value={option}>
            {option}
          </MenuItem>
        ))}
      </Select>
    );
  };

  const handleClearFilters = () => {
    setFilters({ engineer: "", category: "", status: "", customer: "", creator: "" });
  };

  const filteredTickets = useMemo(() => {

    const usersArray = Array.isArray(appUsersList)
      ? appUsersList
      : appUsersList && typeof appUsersList === "object"
        ? Object.values(appUsersList).find(item => Array.isArray(item)) || []
        : [];

    // console.log("usersArray  --", usersArray);

    const customerTickets = allSvcTickets?.data
      ? allSvcTickets.data.filter(ticket => usersArray.find(user => user.userId === ticket.assignerId)?.userRole === "ROLE_CUSTOMER")
      : [];

    const nonCustomerTickets = allSvcTickets?.data
      ? allSvcTickets.data.filter(ticket => usersArray.find(user => user.userId === ticket.assignerId)?.userRole !== "ROLE_CUSTOMER")
      : [];

    let tickets = activeTab === 0 ? nonCustomerTickets : customerTickets;

    if (filters.engineer) tickets = tickets.filter(t => t.assigneeName === filters.engineer);
    if (filters.category) tickets = tickets.filter(t => t.ticketCategory === filters.category);
    if (filters.status) tickets = tickets.filter(t => t.status === filters.status);
    if (filters.customer) tickets = tickets.filter(t => t.customerName === filters.customer);
    if (filters.creator) tickets = tickets.filter(t => t.createdBy === filters.creator);


    if (searchTerm) {
      tickets = tickets.filter(ticket =>
        Object.values(ticket).join(" ").toLowerCase().includes(searchTerm.toLowerCase())
      );
    }

    return tickets;
  }, [filters, searchTerm, activeTab, allSvcTickets, appUsersList]);

  const { engineers, categories, statuses, customers, creators } = useMemo(() => {
    const engineers = new Set();
    const categories = new Set();
    const statuses = new Set();
    const customers = new Set();
    const creators = new Set();

    filteredTickets.forEach((ticket) => {
      if (ticket.assigneeName) engineers.add(ticket.assigneeName);
      categories.add(ticket.ticketCategory);
      statuses.add(ticket.status);
      customers.add(ticket.customerName);
      creators.add(ticket.createdBy);

    });

    return {
      engineers: Array.from(engineers),
      categories: Array.from(categories),
      statuses: Array.from(statuses),
      customers: Array.from(customers),
      creators: Array.from(creators),

    };
  }, [filteredTickets]);

  const handleTabChange = (event, newValue) => {
    setActiveTab(newValue);
    setFilters({ engineer: "", category: "", status: "", customer: "", creator: "" });
    handleClearSearch();
  };

  const onDaysChange = (event, newValue) => setDays(newValue);

  const dateComparator = (v1, v2) => moment(v1).diff(moment(v2));

  const handleSearchChange = (event) => {
    setSearchTerm(event.target.value);
  };

  const handleClearSearch = () => {
    setSearchTerm("");
  };
  const handleCopyAndOpenWhatsApp = async (id) => {
    const result = await dispatch(getSvcTktDetailsForWhatsappMessage(id));
    const ticketData = result.payload;
    if (!ticketData) {
      console.error("No ticket data available");
      return;
    }
    const message = ticketData.Message;
    navigator.clipboard
      .writeText(message)
      .then(() => {
        alert(`Message copied:\n\n${message}`);
      })
      .catch((err) => {
        console.error("Failed to copy text: ", err);
      });
  };
  const { ROLE_DATA_OWNER, ROLE_SERVICE_COORDINATOR } = asyncStorageValues?.allTypes?.USER_ROLES;
  const renderDetailsButton = (params) => {
    const isCreatedByUser = asyncStorageValues?.appUsers?.find((user) => user.userName == userInfo?.username);
    return (
      <strong>
        <Tooltip title="View">
          <Button
            startIcon={<ZoomInIcon />}
            color="primary"
            size="large"
            style={{ fontWeight: "bold", marginLeft: -26 }}
            onClick={() => {
              navigate("/all-service-ticket-view/" + params.row.serviceTicketId);
            }}
          />
        </Tooltip>
        {params.row.status !== asyncStorageValues.allTypes.SERVICE_TICKET_STATUS.ASSIGN_SERVICE_ENGINEER ? (
          <Tooltip title="Whatsapp Message">
            <Button
              startIcon={<WhatsAppIcon />}
              color="primary"
              size="medium"
              style={{ fontWeight: "bold", marginLeft: -20 }}
              onClick={() => {
                handleCopyAndOpenWhatsApp(params.row.serviceTicketId);
              }}
            />
          </Tooltip>
        ) : null}
        {   
  // Check if additional_notes exists and parse it
  !(
    // Check if additional_notes is a string and parse it
    (typeof params.row.additional_notes === "string"
      ? JSON.parse(params.row.additional_notes)
      : params.row.additional_notes
    )?.serviceTicketReportPdf
  ) && (
    (userCurrentRole === ROLE_SERVICE_COORDINATOR) ||
    (userCurrentRole === ROLE_DATA_OWNER && asyncStorageValues?.configData?.dataOwnerPermissions?.create_edit_tickets)
  ) ? (
    <Tooltip title="Edit">
      <Button
        startIcon={<EditIcon />}
        color="primary"
        size="large"
        style={{ fontWeight: "bold", marginLeft: -20 }}
        onClick={() => {
          navigate("/all-service-ticket-view/" + params.row.serviceTicketId, { state: { editMode: true } });
        }
      }
      />
    </Tooltip>
  ) : (
    <span style={{ display: "inline-block", width: "40px", height: "24px" }} />
  )
}


      </strong>
    );
  };
  const columns = [
    { field: "serviceTicketId", headerName: "ID", flex: 0.1 },
    {
      field: "dateCreated",
      headerName: "Date Created",
      flex: 0.2,
      sortComparator: dateComparator,
      valueGetter: (params) => {
        const dateCreated = params.row?.dateCreated;
        if (dateCreated) {
          return moment(dateCreated).format("DD MMM YYYY");
        }
      },
    },
    {
      field: "closedDate",
      headerName: "Closed Date",
      flex: 0.2,
      valueGetter: (params) => {
        const closedDate = params.row?.closedDate;
        if (closedDate) {
          return moment(closedDate).format("DD MMM YYYY");
        }
      },
      sortComparator: dateComparator,
    },
    {
      field: "customerName",
      headerName: "Customer Name",
      width: 60,
      flex: 0.3, renderHeader: () => (
        <FilterDropdown
          label="Customer Name"
          value={filters.customer}
          options={customers}
          onChange={(value) => setFilters((prevFilters) => ({ ...prevFilters, customer: value }))}
        />
      ),
    },
    {
      field: "createdBy",
      headerName: "Created By",
      width: 60,
      flex: 0.3,
      renderHeader: () => (
        <FilterDropdown
          label="Created By"
          value={filters.creator}
          options={creators}
          onChange={(value) => setFilters((prevFilters) => ({ ...prevFilters, creator: value }))}
        />
      ),
    },
    {
      field: "ticketCategory",
      headerName: "Category",
      width: 60,
      flex: 0.3,
      renderHeader: () => (
        <FilterDropdown
          label="Category"
          value={filters.category}
          options={categories}
          onChange={(value) => setFilters((prevFilters) => ({ ...prevFilters, category: value }))}
        />
      ),
    },
    {
      field: "assigneeName",
      headerName: "Service Engineer",
      width: 60,
      flex: 0.3,
      renderHeader: () => (
        <FilterDropdown
          label="Service Engineer"
          value={filters.engineer}
          options={engineers}
          onChange={(value) => setFilters((prevFilters) => ({ ...prevFilters, engineer: value }))}
        />
      ),
    },
    { field: "description", headerName: "Description", width: 60, flex: 0.3 },
    {
      field: "status",
      headerName: "Status",
      width: 60,
      flex: 0.2,
      renderHeader: () => (
        <FilterDropdown
          label="Status"
          value={filters.status}
          options={statuses}
          onChange={(value) => setFilters((prevFilters) => ({ ...prevFilters, status: value }))}
        />
      ),
    },
    {
      field: "col6",
      headerName: "",
      flex: 0.2,
      renderCell: renderDetailsButton,
      disableClickEventBubbling: false,
      sortable: false,
      filterable: false,
    },
  ];

  const downloadCsv = (e) => {
    e.preventDefault();


    const formattedData = allSvcTickets.data.map((ticket) => {
      return {
        serviceTicketId: ticket.serviceTicketId,
        dateCreated: ticket.dateCreated ? moment(ticket.dateCreated).format("DD MM YYYY") : "",
        closedDate: ticket.closedDate ? moment(ticket.closedDate).format("DD MM YYYY") : "",
        customerName: ticket.customerName,
        ticketCategory: ticket.ticketCategory,
        assigneeName: ticket.assigneeName,
        description: ticket.description,
        status: ticket.status,
      };
    });
    const headers = [
      "Service Ticket Id",
      "Date Created",
      "Date Closed",
      "Customer Name",
      "Ticket Category",
      "Service Engineer",
      "Description",
      "Status",
    ];
    const keys = [
      "serviceTicketId",
      "dateCreated",
      "closedDate",
      "customerName",
      "ticketCategory",
      "assigneeName",
      "description",
      "status",
    ];

    exportToCsv(headers, keys, formattedData, `All_Service_Tickets_for_last_${days} days`);
  };

  return (
    <Stack justifyContent="center" >
      <Stack direction={"row"} sx={{ mx: 2, my: 2 }} justifyContent={"space-between"}>
        <Stack direction={"row"} alignItems="center" flexWrap={"wrap"} gap={2}>
          {[
            asyncStorageValues?.allTypes?.USER_ROLES?.ROLE_DATA_OWNER,
            asyncStorageValues?.allTypes?.USER_ROLES?.ROLE_SERVICE_COORDINATOR,
          ].includes(userCurrentRole) &&
            asyncStorageValues?.configData?.dataOwnerPermissions?.create_edit_tickets && (
              <Button
                startIcon={<AddIcon />}
                sx={{ textTransform: "capitalize", height: 55, minWidth: 110, paddingLeft: "10px", paddingRight: "10px" }}
                variant="contained"
                onClick={() => navigate("/add-service-ticket")}
              >
                Create
              </Button>
            )}
          <Autocomplete
            disablePortal
            id="days"
            options={["30", "60", "90", "180"]}
            onChange={onDaysChange}
            value={days}
            sx={{ minWidth: 100 }}
            renderInput={(params) => <TextField {...params} label="Days" />}
          />
          <TextField
            style={{ minWidth: 350 }}
            label="Search"
            value={searchTerm}
            onChange={handleSearchChange}
            InputProps={{
              endAdornment: (
                <InputAdornment position="end">
                  {searchTerm ? (
                    <IconButton edge="end" onClick={handleClearSearch} size="small">
                      <CloseIcon />
                    </IconButton>
                  ) : (
                    <InputAdornment position="end">
                      <SearchIcon />
                    </InputAdornment>
                  )}
                </InputAdornment>
              ),
            }}
          />
          <Button
            variant="contained"
            onClick={handleClearFilters}
            sx={{
              height: "55px",
              minWidth: "130px",
              textTransform: "capitalize",
            }}
          >
            Clear Filters
          </Button>
        </Stack>
        {/* <Button
          variant="contained"
          sx={{ textTransform: "capitalize", height: 50, ml: 1 }}
          onClick={downloadCsv}
          disabled={allSvcTickets.data.length ? false : true}
        >
          Export to CSV
        </Button> */}
      </Stack>
      <Tabs value={activeTab} onChange={handleTabChange} variant="fullWidth"
        TabIndicatorProps={{
          sx: {
            height: 3,
          },
        }}>
        <Tab 
          label="All Service Tickets"
          sx={{
            "&:hover": { backgroundColor: "#f0f0f0" },
              fontWeight: "bold",
              fontSize: "1.1rem", 
          }}
        />
        <Tab
          label="Customer Tickets"
          sx={{
            "&:hover": { backgroundColor: "#f0f0f0" },
              fontWeight: "bold",
              fontSize: "1.1rem",
          }}
        />
      </Tabs>

      <Box style={{ height: 700, width: "100%", paddingLeft: "2%", paddingTop: 3, marginTop: 8, paddingRight: "1%", overflow: "auto" }}>
        {loading || allSvcTickets.loading ? (
          <CircularProgress color="secondary" sx={{ justifyContent: "center", alignItems: "center" }} />
        ) : (
          <DataGrid
            rows={filteredTickets}
            getRowId={(row) => row.serviceTicketId}
            columns={columns}
            pageSize={5}
            rowsPerPageOptions={[5]}
            disableColumnMenu
            localeText={{ noRowsLabel: "No tickets." }}
          />
        )}
      </Box>
    </Stack>
  );
};

export default AllSvcTicketForLastXDays;
